import {useQuery} from 'react-query';
import {getListTakenLoan} from './getListTakenLoan';

const useGetListTakenLoan = () => {
  return useQuery(['list-taken-loan'], () => getListTakenLoan());
};

export default useGetListTakenLoan;
